import { TSFixMe } from '../../../frontend-libs/evlapp-types';

export const fromEntries: TSFixMe = function (iterable: TSFixMe) {
  return [...iterable].reduce((obj, [key, val]) => {
    obj[key] = val;
    return obj;
  }, {});
};
